exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bare-button[data-v-301cefc4] {\n  background: transparent;\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n", ""]);

// exports
